import Bugsnag from "@bugsnag/js";
import * as WebAuthnJSON from "@github/webauthn-json";
import {PublicKeyCredentialCreationOptionsJSON, PublicKeyCredentialRequestOptionsJSON} from "@github/webauthn-json/dist/types/basic/json";

function getCsrfToken() {
  const csrfElement = document.querySelector("meta[name=\"csrf-token\"]");
  if (!csrfElement) { return null; }

  return csrfElement.getAttribute("content");
}

function callback(url: string, body: object) {
  fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": getCsrfToken() || "",
    },
    credentials: "same-origin",
  }).then(function(response) {
    if (response.ok) {
      response.json().then(data => {
        window.location.replace(data.redirect);
      });
    } else if (response.status < 500) {
      // Hopefully we got JSON
      response.json().then(data => {
        const message = data["error"] as string;
        console.error(message);
        Bugsnag.notify(new Error(message));

        if (message.includes("WebAuthn::AttestationStatementVerificationError")) {
          // There are other reasons this can fail, but this is the most common.
          alert("We couldn't verify the details of your device. Please allow your browser to share information about your device.");
        } else {
          alert(message);
        }
      }).catch(Bugsnag.notify);
    } else {
      console.error(response);
      const error = new Error("Invalid response received from server.");
      Bugsnag.notify(error);
    }
  });
}

function create(callbackUrl: string, label: string, credentialOptions: PublicKeyCredentialCreationOptionsJSON) {
  WebAuthnJSON.create({publicKey: credentialOptions}).then(function(credential) {
    callback(callbackUrl, {credentials: {credential, label}});
  }).catch(function(err) {
    console.error(err);

    switch (err.name) {
    case "AbortError":
    case "NotAllowedError":
      // User cancelled, or permission error.
      break;
    case "InvalidStateError":
      if (err.message === "The user attempted to register an authenticator that contains one of the credentials already registered with the relying party.") {
        // Chrome only
        alert("You have already registered this security key. Please try another.");
        break;
      }

      if (err.message === "An attempt was made to use an object that is not, or is no longer, usable") {
        // Firefox only
        alert("You have already registered this security key. Please try another.");
        break;
      }

      alert(err.message);
      break;

    default:
      Bugsnag.notify(err);
      alert(err.message);
      break;
    }

    window.location.reload();
  });

  console.info("Creating new public key credential...");
}

function get(callbackUrl: string, credentialOptions: PublicKeyCredentialRequestOptionsJSON) {
  WebAuthnJSON.get({publicKey: credentialOptions}).then(function(credential) {
    callback(callbackUrl, credential);
  }).catch(function(err) {
    console.error(err);

    switch (err.name) {
    case "AbortError":
    case "NotAllowedError":
      // User cancelled, or permission error.
      break;
    default:
      Bugsnag.notify(err);
      alert(err.message);
      break;
    }

    window.location.reload();
  });

  console.info("Getting public key credential...");
}

export {create, get};
